import React, { memo } from "react";
import { PropsWithChildren } from "react";
import { Box, Button, FormControlLabel } from "@mui/material";
import { Typography } from "@mui/material";
import { Field } from "@onair/minimal-ui/hook-form";
import SortableItem from "./sortable-item";
import { SurveyFieldType } from "@onair/repositories";
import QuestionItemSelection from "./item-types/question-item-selection";
import QuestionItemText from "./item-types/question-item-text";
import QuestionItemRating from "./item-types/question-item-rating";
import CustomSwitch from "./custom-switch";
import { Iconify } from "@onair/minimal-ui/iconify";
import QuestionTypeSelector from "./question-type-selector";
import { FieldArrayWithId, UseFormReturn } from "react-hook-form";
import { CreateSurveyFormFields } from "../../survey-form.schema";

interface QuestionItemProps extends PropsWithChildren {
	id: string;
	index: number;
	methods: UseFormReturn<CreateSurveyFormFields>;
	value?: CreateSurveyFormFields["fields"][number];
	error: string | undefined;
	onChangeQuestionType: (type: SurveyFieldType, index: number) => void;
	onChangeRequired: (checked: boolean, index: number) => void;
	onRemove: (index: number) => void;
}
const QuestionItem: React.FC<QuestionItemProps> = ({
	id,
	index,
	methods,
	value,
	error,
	onChangeQuestionType,
	onChangeRequired,
	onRemove,
}) => {
	return (
		<SortableItem
			id={id}
			label={<>Câu {index + 1}</>}
			selector={
				<QuestionTypeSelector
					value={value?.type}
					onChange={(type) => onChangeQuestionType(type, index)}
				/>
			}
		>
			<Box component="div" className="question-item__body cursor-auto">
				<Box component="div" className="mb-3">
					<Typography variant="subtitle2" gutterBottom>
						Câu hỏi
					</Typography>
					<Field.Editor
						name={`fields.${index}.label`}
						value={value?.label}
						placeholder="Nhập câu hỏi"
						resourceItem
					/>
				</Box>
				{error && (
					<Typography component="p" className="text-red-500 text-xs">
						{error}
					</Typography>
				)}
				<Box component="div">
					{(value?.type === SurveyFieldType.CHECKBOX ||
						value?.type === SurveyFieldType.RADIO ||
						value?.type === SurveyFieldType.SELECT) && (
						<QuestionItemSelection
							index={index}
							methods={methods}
							showFieldOther={value?.type !== SurveyFieldType.SELECT}
						/>
					)}
					{value?.type === SurveyFieldType.TEXTAREA && <QuestionItemText />}
					{value?.type === SurveyFieldType.RATING && <QuestionItemRating />}
				</Box>
				<Box
					component="div"
					className="question-item__footer border-t border-dashed pt-6 mt-3 cursor-auto"
				>
					<Box component="div">
						<FormControlLabel
							control={<CustomSwitch checked={value?.required} />}
							label="Bắt buộc"
							name={`fields.${index}.required`}
							onChange={(_, checked) => onChangeRequired(checked, index)}
						/>
						<Button
							startIcon={
								<Iconify
									icon="solar:trash-bin-trash-bold"
									className="text-gray-600"
								/>
							}
							className="font-normal"
							onClick={() => onRemove(index)}
						>
							Xoá
						</Button>
					</Box>
				</Box>
			</Box>
		</SortableItem>
	);
};
export default memo(QuestionItem);
